import type { IRecipeDetail } from "modules/Recipes/store/types";
import Image from "../Image";
import NoteItem from "../NoteItem";

export type IProps = {
  id?: number;
  dataItem: IRecipeDetail;
  className?: string;
  name?: string;
  showNote?: boolean;
  active?: boolean;
  image?: string;
  handleClick?: (e: any) => void;
  handleClickNote?: (id: number, state: boolean) => void;
  type?: number;
  showConfirmRemoveNote?: boolean;
  reload?: (newState: boolean) => void;
  recipeRequestId?: any;
};

const ProductListItem = ({
  id,
  recipeRequestId,
  className,
  name,
  showNote,
  dataItem,
  image,
  handleClick,
  handleClickNote,
  type,
  active,
  showConfirmRemoveNote,
  reload,
}: IProps) => {

  const _handleClick = () => {
    handleClick?.(dataItem)
  };

  const onNoteChange = (id: number, state: boolean) => {
    console.log({id, state})
    handleClickNote?.(id, state);
  };
  
  return (
    <>
      {type === 1 ? (
        <div className={`rounded-md ${className}`} onClick={_handleClick}>
          <div className="relative w-full h-[120px]">
            <Image
              src={image || ''}
              alt={image || ''}
              className="object-cover w-full h-full rounded-md"
            />
            {showNote && <NoteItem
              id={id || dataItem.id}
              recipeRequestId={recipeRequestId || dataItem?.recipe_request_id}
              active={active}
              showConfirmRemoveNote={showConfirmRemoveNote}
              onChange={onNoteChange}
              reload={reload}
            />}
          </div>
          <p className="mt-[6px] text-[13px] font-medium text-dark line-clamp-2">
            {name}
          </p>
        </div>) :
        (<div className={`rounded-md ${className}`} onClick={_handleClick}>
          <div className="relative w-full h-full min-h-[120px]">
            <Image
              src={image || ''}
              alt={image || ''}
              className="object-cover w-full h-full rounded-md"
            />
            {showNote && <NoteItem
              id={id || dataItem.id}
              active={active}
              showConfirmRemoveNote={showConfirmRemoveNote}
              onChange={onNoteChange}
              reload={reload}
            />}
            <p className="absolute z-10 px-3 bottom-[14px] mt-[6px] text-white line-clamp-2 text-[13px]">
              {name}
            </p>
            <div className="rounded-md w-full absolute left-0 bottom-0 h-[50px] bg-gradient-to-b from-transparent to-black/80 "></div>
          </div>
          
        </div>)
      }
    </>
  );
};


export default ProductListItem;
